import mailChimpAutoSync from './mailChimpAutoSync.component';

export default angular
  .module('st.Integrations.MailChimp', [])
  .component('mailChimpAutoSync', mailChimpAutoSync)
  .service('mailChimpService', ($q, $http, dataService, MAIL_CHIMP) => ({
    authenticate: () =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.get,
        MAIL_CHIMP.API.AUTHENTICATE,
        {}
      ),
    authenticated: (params) =>
      dataService.apiRequest(null, null, true, null, $http.get, MAIL_CHIMP.API.AUTHENTICATED, {
        params
      }),
    deauthenticate: () =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.get,
        MAIL_CHIMP.API.DEAUTHENTICATE,
        {}
      ),
    listAddTo: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        MAIL_CHIMP.API.LIST_ADD_TO,
        {
          params
        },
        null,
        true
      ),
    listCreate: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        MAIL_CHIMP.API.LIST_CREATE,
        {
          params
        },
        null,
        true
      ),
    lists: () =>
      dataService.apiRequest(null, null, true, null, $http.get, MAIL_CHIMP.API.LISTS, {}),
    sync: (params) =>
      dataService.apiRequest(null, null, true, null, $http.post, MAIL_CHIMP.API.SYNC, {
        params
      })
  }))
  .constant('MAIL_CHIMP', {
    API: {
      AUTHENTICATE: '/api/v1/integration/mailChimp/authenticate',
      AUTHENTICATED: '/api/v1/integration/mailChimp/authenticated',
      DEAUTHENTICATE: '/api/v1/integration/mailChimp/deauthenticate',
      LIST_ADD_TO: '/api/v1/integration/mailChimp/list-add-to',
      LIST_CREATE: '/api/v1/integration/mailChimp/list-create',
      LISTS: '/api/v1/integration/mailChimp/lists',
      SYNC: '/api/v1/integration/mailChimp/sync'
    }
  });
